import { render, staticRenderFns } from "./CompareCity.vue?vue&type=template&id=2203bb16&scoped=true"
import script from "./CompareCity.vue?vue&type=script&lang=js"
export * from "./CompareCity.vue?vue&type=script&lang=js"
import style0 from "./CompareCity.vue?vue&type=style&index=0&id=2203bb16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203bb16",
  null
  
)

export default component.exports